module.exports = __webpack_public_path__ + "img/desserts.10e1fcfc.svg";